/*
  Updates meta tags in head
*/
import { tracking } from '../../utilities';

const defaultMeta = {
  description: '',
  ogImage: `${window.location.origin}/assets/ogimage.jpg`,
  ogImageHeight: 630,
  ogImageWidth: 1200,
  templateTitle: data => `${data.title} - praesens`,
  title: '',
};

let metaDescription;
let metaOgTitle;
let metaOgUrl;
let metaOgDescription;
let metaOgImage;
let metaOgImageWidth;
let metaOgImageHeight;

// NOTE: will not be called on the first view, only after a pushState-triggered view change
function render(data = {}) {
  let title;
  if (data.title) {
    title = data.title; // eslint-disable-line prefer-destructuring
  } else {
    title = (data.meta_title) ?
      defaultMeta.templateTitle({ title: data.meta_title })
      : defaultMeta.title;
  }
  if (metaDescription) {
    metaDescription.setAttribute('content', data.meta_description || defaultMeta.description);
  }
  if (metaOgDescription) {
    metaOgDescription.setAttribute('content', data.meta_description || defaultMeta.description);
  }
  if (metaOgTitle) {
    metaOgTitle.setAttribute('content', title || title);
  }
  if (metaOgUrl) {
    metaOgUrl.setAttribute('content', data.url || window.location.origin + window.location.pathname);
  }
  if (metaOgImage) {
    metaOgImage.setAttribute('content', data.og_image || defaultMeta.ogImage);
  }
  if (metaOgImageWidth) {
    metaOgImageWidth.setAttribute('content', data.og_image_width || defaultMeta.ogImageWidth);
  }
  if (metaOgImageHeight) {
    metaOgImageHeight.setAttribute('content', data.og_image_height || defaultMeta.ogImageHeight);
  }
  document.title = title;
  tracking.trackPageView();
}

function cacheMetaElements() {
  const metas = document.querySelectorAll('meta');
  [].forEach.call(metas, (meta) => {
    const metaName = meta.getAttribute('name');
    const metaProperty = meta.getAttribute('property');
    if (metaName && metaName === 'description') {
      metaDescription = meta;
      return;
    }
    if (!metaProperty) {
      return;
    }
    switch (metaProperty) { // eslint-disable-line default-case
      case 'og:description':
        metaOgDescription = meta;
        break;
      case 'og:title':
        metaOgTitle = meta;
        break;
      case 'og:url':
        metaOgUrl = meta;
        break;
      case 'og:image':
        metaOgImage = meta;
        break;
      case 'og:image:width':
        metaOgImageWidth = meta;
        break;
      case 'og:image:height':
        metaOgImageHeight = meta;
        break;
    }
  });
}

function extractMetaValues(code) {
  const headCode = code.split('<head>')[1].split('</head>')[0] || '';
  let headEl = document.createElement('div');
  headEl.innerHTML = headCode;
  const metas = headEl.querySelectorAll('meta');
  const data = {};
  const titleEl = headEl.querySelector('title');
  if (titleEl) {
    data.title = titleEl.innerHTML;
  }

  [].forEach.call(metas, (meta) => {
    const metaName = meta.getAttribute('name');
    const metaProperty = meta.getAttribute('property');
    const metaContent = meta.getAttribute('content') || '';
    if (metaName && metaName === 'description') {
      data.description = metaContent;
    } else if (metaProperty) {
      switch (metaProperty) { // eslint-disable-line default-case
        case 'og:image':
          data.ogImage = metaContent;
          break;
        case 'og:image:width':
          data.ogImageWidth = metaContent;
          break;
        case 'og:image:height':
          data.ogImageHeight = metaContent;
          break;
      }
    }
  });

  headEl = null;

  return data;
}

function init() {
  cacheMetaElements();
}

export default {
  extractMetaValues,
  init,
  render,
};
